import React from 'react';
import logo from '../assets/icons/logo.png';
import translate from '../i18n/translate';

const Footer = () => {
    return (
        <footer>
            <div className='container'>
                <div className='cover_outside'>
                    <div className='left_col'>
                        <a className='logo' href='#main-content'>
                            <img src={logo} alt='Axiomatika' />
                        </a>
                        <div className='copyright'>© 2018 Axiomatika</div>
                    </div>
                    <div className='menu_block'>
                        {translate('fCompanyName')}<br/>
                        {translate('fCompanyAddress')}<br/>
                        {translate('fCompanyVlgAddress')}<br/>
                        {translate('fCompanyINN')}<br/>
                        e-mail: info@axiomatika.ru<br/>
                        {translate('fPhone')}: +7 495 215-16-71<br/>
                    </div>
                    <div className='menu_block'>
                        {translate('fStack')}: <br/>
                        Java, Spring, JavaScript, Angular, CSS, HTML
                    </div>
                </div>

                <br/>
                {translate('fOKVED')}
                <br/>
                {translate('fActivityType')}
                <br/>
                {translate('fDeveloperText')} <a href='https://reestr.digital.gov.ru/promo/owner/2523075/2407195/'>{translate('fDeveloperName')}</a>
                <br/>
                {translate('fCertificate')}
                <br/>
                <a href='https://reestr.digital.gov.ru/reestr/2523075/'>{translate('fRegistryRecord')}</a>

            </div>
        </footer>
    );
};

export default Footer;
